import React from 'react';
import { motion } from 'framer-motion';
export function Differentiation() {
  return <section className="py-24 px-6 bg-white" data-id="element-17">
      <div className="max-w-2xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 text-charcoal" data-id="element-20">
            Why this is different from the things you tried
          </h2>

          <p className="text-xl text-charcoal/80 mb-12 leading-relaxed" data-id="element-21">
            Because it's not asking you to become a new person.
          </p>

          <div className="bg-linen p-8 rounded-xl border border-charcoal/5 mb-12 text-left" data-id="element-22">
            <p className="font-bold text-charcoal mb-4 uppercase tracking-wide text-sm" data-id="element-23">
              It's not asking you to:
            </p>
            <ul className="space-y-3 mb-8" data-id="element-24">
              <li className="flex items-center gap-3 text-charcoal/70 line-through decoration-terracotta/50 decoration-2" data-id="element-25">
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta/50" data-id="element-26" />
                Be patient all day
              </li>
              <li className="flex items-center gap-3 text-charcoal/70 line-through decoration-terracotta/50 decoration-2" data-id="element-27">
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta/50" data-id="element-28" />
                Clean your whole house
              </li>
              <li className="flex items-center gap-3 text-charcoal/70 line-through decoration-terracotta/50 decoration-2" data-id="element-29">
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta/50" data-id="element-30" />
                Implement a perfect schedule
              </li>
            </ul>

            <p className="text-lg font-serif text-charcoal border-l-4 border-muted-blue pl-4 py-1" data-id="element-31">
              It's asking you to lock three tiny doors—so chaos can't keep
              running through your house like it owns it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}